import styled from "@emotion/styled";
import React from "react";
import { PublicVisitBroadcastDetailsTypes } from "../messages";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { canSelectAllDays } from "../utils/flexibleVisitUtils";
import AvailableFlexibleShiftLeading from "./AvailableFlexibleShiftLeading";
import { AppListItem } from "./Generic/AppList";
import Flex from "./Generic/Flex";
import { If } from "./Generic/If";

interface Props {
  visit: PublicVisitBroadcastDetailsTypes.FlexiblePattern;
  areAllShiftsChecked: boolean;
  showSelectAll: boolean;
  headerTitle: string | null;
  onToggleAllDays: () => void;
}

const AvailableFlexibleDatesHeader = (props: Props) => {
  if (props.headerTitle === null && !canSelectAllDays(props.visit)) {
    return null;
  }

  return (
    <FlexibleDatesHeaderContainer
      title={
        <Flex
          direction={props.showSelectAll ? "row" : "row-reverse"}
          justifyContent="space-between"
          alignItems="center"
        >
          <If condition={props.showSelectAll}>
            <SelectAllCheckbox {...props} />
          </If>
          <HeaderTitle>{props.headerTitle}</HeaderTitle>
        </Flex>
      }
    />
  );
};

function SelectAllCheckbox(props: Props) {
  return (
    <Flex direction="row" xGap={16} alignItems="center">
      <AvailableFlexibleShiftLeading
        isChecked={props.areAllShiftsChecked}
        onClick={props.onToggleAllDays}
      />
      <span onClick={props.onToggleAllDays}>{translate(STRINGS.SELECT_ALL)}</span>
    </Flex>
  );
}

const FlexibleDatesHeaderContainer = styled(AppListItem)`
  padding-top: 0 !important;
`;

const HeaderTitle = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: var(--primary-color);
`;

export default AvailableFlexibleDatesHeader;
